'use strict';

angular.module('AcaApp').directive('ngLastRepeat', [
  'LockedScreenService',
  function(LockedScreenService){
    return {
      link: function($scope){
        if($scope.$last === true){
          LockedScreenService.enableAutomaticOpenWindows();
        }
      }
    };
  }
]);